const BetTypeCodes = {
  Lose: 0,
  Win: 1,
  Pending: 2,
  Canceled: 3,
  Unknown: 4,
  Calculation: 5,
  OnCancel: 6,
};

Object.freeze(BetTypeCodes);

export { BetTypeCodes };
